



























import camelCase from 'lodash/camelCase'
import TableCell from '@/components/TableCell.vue'
import { ORDERED_REQUIRED_ACTIONS } from '../constants'

export default {
  components: {
    TableCell
  },
  props: {
    actions: { type: Array, required: true },
    hSpan: { type: Number, default: 4 }
  },
  computed: {
    formattedActions() {
      const filteredOrderedActions = ORDERED_REQUIRED_ACTIONS.filter(action =>
        this.actions.includes(action)
      )
      const { length } = filteredOrderedActions

      if (!length) return []
      return filteredOrderedActions.slice(0, 2).map((key, i) => {
        if (filteredOrderedActions.length > 2 && i === 1) {
          return (
            this.$t(`myTransports.transportRow.actions.${camelCase(key)}`) +
            ' ' +
            this.$tc('myTransports.transportRow.actions.items', length - 2, length - 2)
          )
        }
        return this.$t(`myTransports.transportRow.actions.${camelCase(key)}`)
      })
    }
  }
}
